import {
  EMPTY_LIST,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { ActionSelect } from '../../Action'

function EntityProfileHeaderTitleActionsSelect({
  actions = EMPTY_LIST,
  className,
  isLoading,
  onClickAction,
}) {
  return actions.length > 0 || isLoading ? (
    <ActionSelect
      actions={actions}
      className={className}
      floatingConfig={{
        placement: FLOATING_ELEMENT_PLACEMENT.bottomEnd,
      }}
      isInitiating={isLoading}
      onClickAction={onClickAction}
    />
  ) : null
}

export default EntityProfileHeaderTitleActionsSelect
